import { Card, Icon, Typography } from 'components';
import { CardErrorBoundaryWithSpinfinity } from 'components/Card/CardErrorBoundaryWithSpinfinity';
import styles from './MicrobiomeSeedingCard.module.css';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';

export const MicrobiomeSeedingCard = () => {
  const { currentKitId } = useCurrentKitAndTinyAccount();

  return (
    <CardErrorBoundaryWithSpinfinity cardName="MicrobiomeSeedingCard">
      <Card
        clickable={{
          href: `/results/${currentKitId}/seeding`,
          text: 'Microbiome seeding',
          isExternal: false,
        }}
      >
        <div className={styles.titleContainer}>
          <Typography variant='heading-s' className={styles.textLink}>
            Microbiome seeding
          </Typography>
          <Icon name='chevronForward' size='s' className={styles.titleIcon} />
        </div>
        <div className={styles.contentContainer}>
          <Typography variant='body-m'>Seeding from mother to child</Typography>
          <Typography variant='body-s' serif className={'dark-grey'}>
            See what microbes you and your baby share (valid in the first 6
            months).
          </Typography>
        </div>
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
};
